{
  "position": "left",
  "visibility": "false",
  "image": {
    "src":"assets/imgs/new.png"
  },
  "label": "",
  "options": {},
  "url": "/",

  "loginLabel":{
    "text": "Login"
  }


}
